import styled from 'styled-components';
import Modal from '../../../Modal';

export const Cart = styled(Modal)`
  max-width: 936px;

  @media (max-width: 768px) {
    max-width: 650px;
  }

  @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
    padding-bottom: 0;
    height: calc(100 * var(--full-vh, 1vh));
    margin: 0;
    max-width: none;
    max-height: calc(100 * var(--full-vh, 1vh));
    min-height: calc(100 * var(--full-vh, 1vh));
  }

  @media (orientation: landscape) and (min-height: 501px) and (max-width: 1023px) {
    max-width: 95vw;
  }

  .ant-modal-body {
    padding: 52px 52px 32px 52px;

    @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
      flex: 1 1 auto;
      width: 100%;
      min-width: 0;
      min-height: 0;
      max-width: 100%;
      padding: 0;
      overflow-x: hidden;
      overflow-y: auto;
      overscroll-behavior: contain;
      -webkit-overflow-scrolling: touch;
    }

    @media (orientation: landscape) and (min-height: 501px) and (max-width: 1023px) {
      padding: 32px 24px;
      overflow-x: hidden;
    }
  }

  .ant-modal-content {
    @media (max-width: 767px), (orientation: landscape) and (max-height: 500px) {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      min-width: 0;
      border-radius: 0;
      max-width: 100%;
      min-height: 0;
      overflow: hidden;
    }

    @media (orientation: landscape) and (min-height: 501px) and (max-width: 1023px) {
      overflow: hidden;
    }
  }
`;
